import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { RadioOption } from './RadioOption';

/**
 * Use RadioOption instead.
 *
 * This exists for backwards compatibility only.
 *
 * @deprecated
 */
export var RadioInline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(RadioOption, _extends({
    ref: ref
  }, props, {
    inline: true
  }));
});
RadioInline.displayName = 'RadioInline';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZWFjdCIsIlJhZGlvT3B0aW9uIiwiUmFkaW9JbmxpbmUiLCJmb3J3YXJkUmVmIiwicHJvcHMiLCJyZWYiLCJkaXNwbGF5TmFtZSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1JhZGlvL1JhZGlvSW5saW5lLmpzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBSYWRpb09wdGlvbiB9IGZyb20gJy4vUmFkaW9PcHRpb24nO1xuXG4vKipcbiAqIFVzZSBSYWRpb09wdGlvbiBpbnN0ZWFkLlxuICpcbiAqIFRoaXMgZXhpc3RzIGZvciBiYWNrd2FyZHMgY29tcGF0aWJpbGl0eSBvbmx5LlxuICpcbiAqIEBkZXByZWNhdGVkXG4gKi9cbmV4cG9ydCBjb25zdCBSYWRpb0lubGluZSA9IFJlYWN0LmZvcndhcmRSZWYoKHByb3BzLCByZWYpID0+IChcbiAgPFJhZGlvT3B0aW9uIHJlZj17cmVmfSB7Li4ucHJvcHN9IGlubGluZSAvPlxuKSk7XG5cblJhZGlvSW5saW5lLmRpc3BsYXlOYW1lID0gJ1JhZGlvSW5saW5lJztcbiJdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU9BLEtBQUssTUFBTSxPQUFPO0FBRXpCLFNBQVNDLFdBQVcsUUFBUSxlQUFlOztBQUUzQztBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBLE9BQU8sSUFBTUMsV0FBVyxnQkFBR0YsS0FBSyxDQUFDRyxVQUFVLENBQUMsVUFBQ0MsS0FBSyxFQUFFQyxHQUFHO0VBQUEsb0JBQ3JELG9CQUFDLFdBQVc7SUFBQyxHQUFHLEVBQUVBO0VBQUksR0FBS0QsS0FBSztJQUFFLE1BQU07RUFBQSxHQUFHO0FBQUEsQ0FDNUMsQ0FBQztBQUVGRixXQUFXLENBQUNJLFdBQVcsR0FBRyxhQUFhIn0=